import { store as auth } from '@/views/auth'
import { store as accessLocations } from '@/views/access-locations'
import { store as profile } from '@/views/profile';
import { store as revoke } from '@/views/revoke';
import { store as protocols } from '@/views/protocols';
import { store as activityRecords } from '@/views/activity-records';

export default {
  auth,
  accessLocations,
  profile,
  revoke,
  protocols,
  activityRecords
}